import Dialog from './Dialog.vue'

var plugin = {}

plugin.install = function (Vue, options = {}) {

    const DialogController = Vue.extend(Dialog)

    Vue.prototype.$dialog = (option = {}) => {
        return new Promise((resolve, reject) => {

            var instance = new DialogController().$mount(document.createElement('div'))
            instance.show = true
            instance.resolve = resolve
            instance.reject = reject
            if (typeof option === 'string') {
                instance.message = option
            } else {
                Object.keys(option).forEach(key => {
                    instance[key] = option[key]
                })
            }
            instance.$nextTick(() => {
                document.body.appendChild(instance.$el)
                instance.waitingFn && instance.waitingFn()
                if (instance.timeout > 0) {
                    instance.timer = setInterval(() => {
                        instance.timeout--;
                        if (instance.timeout === 0) {
                            clearInterval(instance.timer)
                            instance.timer = null
                            instance.waitOverFn() && instance.waitOverFn()
                        }
                    }, 1000)
                }
            })
        })

    }
}

export default plugin


// WEBPACK FOOTER //
// ./src/plugins/Dialog/Index.js